module.exports = __webpack_public_path__ + "static/experience_scene1-902b6ca4a4d60007826ac7236edde707.svg";